import React, { useEffect, useId, useState } from "react";
import { Form } from "react-bootstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import { request } from "../../api/http";
import { buildListQuery } from "../../api/query";
import { SelectLoadingIndicator } from "../../shared/UxbiSpinner";

export async function loadSatProducts(search, page = 1) {
  const filters = search ? [{ condition: "AND", group: ["clave", "descripcion"].map(property => ({ property, operator: "LIKE", value: search.trim(), condition: "OR" })) }] : [];
  const data = await request(`facturacion/catalogos/sat/productos?${buildListQuery({ page, limit: 25, filters })}`);
  return { options: data.data || [], hasMore: page < Number(data.last_page || 1), additional: { page: page + 1 } };
}
export default function SatProductSelect({ value, onChange, disabled }) {
  const id = useId();
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    if (!value) { setSelected(null); return () => { active = false; }; }
    if (String(selected?.clave) === String(value)) return () => { active = false; };
    setSelected({ clave: String(value) });
    const filters = [{ property: "clave", operator: "=", value: String(value) }];
    request(`facturacion/catalogos/sat/productos?${buildListQuery({ limit: 1, filters })}`).then(data => {
      if (active && data.data?.[0]) setSelected(data.data[0]);
    }).catch(() => { /* Preserve the persisted key if its description cannot be loaded. */ });
    return () => { active = false; };
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  return <Form.Group controlId={id}>
    <Form.Label>Clave de producto / servicio SAT</Form.Label>
    <AsyncPaginate inputId={id} value={selected} additional={{ page: 1 }}
      loadOptions={async (search, loaded, { page }) => { setError(""); try { return await loadSatProducts(search, page); } catch(e) { setError("No se pudo consultar el catálogo SAT. Vuelve a buscar para reintentar."); throw e; } }}
      getOptionValue={option => String(option.clave)} getOptionLabel={option => `${option.clave}${option.descripcion ? ` · ${option.descripcion}` : ""}`}
      onChange={option => { setSelected(option); onChange(option?.clave || ""); }}
      placeholder="Buscar por clave o descripción…" debounceTimeout={300} isClearable isDisabled={disabled}
      components={{ LoadingIndicator: SelectLoadingIndicator }} loadingMessage={() => "Cargando catálogo SAT…"} noOptionsMessage={() => "No hay claves coincidentes"}
      styles={{ control: base => ({ ...base, minHeight: 42 }) }} />
    {error && <div className="text-danger small mt-2" role="alert">{error}</div>}
  </Form.Group>;
}
